import {
  Button,
  Grid,
  makeStyles,
  Typography,
  Hidden,
} from "@material-ui/core";
import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import StarIcon from "@material-ui/icons/Star";
import { Link } from "react-router-dom";
function ExtendCard(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      marginTop: "20px",
      width: "100%",
    },
    body: {},
    photo: {
      position: "relative",
      width: 400,
      margin: " 0 25px 0  0",
      [theme.breakpoints.down("sm")]: {
        textAlign: "center",
      },
    },
    mainPic: {
      borderRadius: 10,
    },
    superHost: {
      position: "absolute",
      top: 10,
      left: 10,
    },
    info: {
      position: "relative",
      padding: 0,
      [theme.breakpoints.up(1030)]: {
        margin: "0 20px 0 0",
      },
      [theme.breakpoints.between("xs", "sm")]: {
        margin: "20px 0 0 0",
      },
      [theme.breakpoints.between("sm", "md")]: {
        margin: "0 20px 0 0",
      },
      [theme.breakpoints.between("md", 1030)]: {
        margin: "20px 20px 0 0",
      },
    },
    favorite: {
      color: "#ec524b",
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
    notFavorite: {
      color: "#7e7474",
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
    cityName: {
      marginTop: 0,
      width: "100%",
    },
    title: {},
    conveniences: {
      marginBottom: 40,
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
    typo1: {
      color: "#7e7474",
      fontSize: 15,
    },
    typo2: {
      color: "#1a1c20",
      fontSize: 20,
    },
    rate: {
      position: "absolute",
      bottom: 0,
    },
    starIcon: { margin: "auto 5px auto 0", fontSize: 20, color: "#fd3a69" },
    priceRate: { color: "#222831", fontWeight: "bold", fontSize: 20 },
    shortLine: {
      border: "1px solid none",
      borderTop: "1px solid #e8e8e8",
      width: "20%",
      margin: "3% 0 0 0",
      [theme.breakpoints.down("sm")]: {  height: "20px", margin: "3% 0 3% 0" },
      height: "10px",
    },
    line: {
      borderBottom: "1px solid #e8e8e8",
      width: "95%",
      [theme.breakpoints.down("sm")]: { width: "70%", },
      height: "10px",
      margin: "0 0 30px 0",
      height: 20,
    },
  }));

  const classes = useStyles();

  const [getLike, setLike] = useState(false);
  function IsLike() {
    setLike(!getLike);
  }

  return (
    <div className={classes.root} onMouseEnter={() => {}}>
      
      <div className={classes.line} />

      <Grid container>
        <Grid
          xs={12}
          sm={5}
          md={12}
          lg={5}
          xl={4}
          container
          justify="flex-start"
          className={classes.photo}
        >
          <img className={classes.mainPic} src={props.mainPic} />
          <Button
            variant="contained"
            size="small"
            color="default"
            className={classes.superHost}
          >
            Chủ nhà siêu cấp
          </Button>
        </Grid>

        <Grid xs={12} sm={6} md={12} lg={6} xl={7} className={classes.info}>
          <Hidden smUp>
            <Grid container alignItems="center" item xs={6}>
              <StarIcon className={classes.starIcon} />
              <Typography className={classes.priceRate}>
                {props.rate}
              </Typography>
              <Typography className={classes.typo1}>
                ({props.rateNo})
              </Typography>
            </Grid>
          </Hidden>
          <div className={classes.cityName}>
            <Grid container xs={12}>
              <Grid item xs={11}>
                <Typography className={classes.typo1}>
                  Phòng riêng tại {props.cityName}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <FavoriteBorderIcon
                  variant="outlined"
                  onClick={IsLike}
                  className={getLike ? classes.favorite : classes.notFavorite}
                />
              </Grid>
            </Grid>
          </div>
          <div className={classes.title}>
            <Typography className={classes.typo2}>{props.title}</Typography>
          </div>
          <div className={classes.shortLine} />
          <div className={classes.conveniences}>
            <Typography className={classes.typo1}>
              {props.maxGuestNo} khách. {props.roomNo} phòng ngủ. {props.bedNo}
              phòng vệ sinh.
            </Typography>
          </div>
          <Grid container alignItems="center" className={classes.rate}>
            <Hidden xsDown>
              <Grid container alignItems="center" item xs={6}>
                <StarIcon item className={classes.starIcon} />
                <Typography className={classes.priceRate}>
                  {props.rate}
                </Typography>
                <Typography className={classes.typo1}>
                  ({props.rateNo})
                </Typography>
              </Grid>

              <Grid
                container
                alignItems="center"
                item
                justify="flex-end"
                xs={6}
              >
                <Typography className={classes.priceRate}>
                  {props.price}
                </Typography>
                <Typography style={{ color: "#7e7474", fontSize: 18 }}>
                  /đêm
                </Typography>
              </Grid>
            </Hidden>
            <Hidden smUp>
              <Grid
                container
                item
                alignItems="center"
                justify="flex-start"
                xs={6}
              >
                <Typography className={classes.priceRate}>
                  {props.price}
                </Typography>
                <Typography style={{ color: "#7e7474", fontSize: 18 }}>
                  /đêm
                </Typography>
              </Grid>
            </Hidden>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default ExtendCard;
